var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20022 18.385V16.8L9.82596 18.385H8.20022ZM21.1013 7.17701L11.2753 16.764L9.64956 15.177L19.4755 5.592L21.1013 7.17701ZM24 7.20899L19.4755 2.79599L6.15017 15.796V20.209H10.6746L24 7.20899ZM17.2205 17.4H15.1663V22H2.05006V2H15.3754V3.6H17.4254V0H0V24H17.2205V17.4ZM4.10011 6.0004H12.3004V4.0004H4.10011V6.0004ZM4.10011 10.0004H9.22525V8.0004H4.10011V10.0004ZM4.10011 14.0004H6.15017V12.0004H4.10011V14.0004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIcon);
export default __webpack_public_path__ + "static/media/SurveyIcon.cbfa55618604f8b700fa3a06ed328acf.svg";
export { ForwardRef as ReactComponent };